import { Fragment } from 'react';
import { confirmedFree, external, solanaPrices, stripePrice, formatCardPrice } from '../../lib/products/publicProduct';

/** Display only: amounts come from the existing Stripe and configured crypto prices. */
export function ProductPrices({ product, cardPrice, loadingCardPrice = false, compact = false }) {
  const free = confirmedFree(product);
  const isExternal = external(product);
  const crypto = solanaPrices(product);
  const cardEnabled = product?.stripeConfig?.enabled === true;
  const card = cardEnabled ? stripePrice(cardPrice) : null;
  const loading = cardEnabled && loadingCardPrice;
  const primaryCrypto = !card && !loading ? crypto.find((price) => price.currency === 'USDC') || crypto[0] : null;
  const secondaryCrypto = primaryCrypto ? crypto.filter((price) => price.currency !== primaryCrypto.currency) : crypto;
  const status = !free && !isExternal && !card && !primaryCrypto;
  const cardUnavailable = !free && !isExternal && cardEnabled && !loading && !card && primaryCrypto;
  let primary;

  if (free) {
    primary = compact ? 'Free - Sign in to download' :
      <><strong>Free</strong> - Google sign-in required to download.</>;
  } else if (isExternal) {
    primary = compact ? 'Price on external store' : 'Price and purchase on the external store.';
  } else if (loading) {
    primary = 'Loading card price...';
  } else if (card) {
    primary = <><strong>{formatCardPrice(cardPrice)}</strong><span className="product-price-method"> - Card</span></>;
  } else if (primaryCrypto) {
    primary = <><strong>{primaryCrypto.amount} {primaryCrypto.currency}</strong><span className="product-price-method" title="Solana network"> (Sol)</span></>;
  } else if (cardEnabled) {
    primary = compact ? 'Card pricing unavailable' : 'Card pricing unavailable. Confirm the price at checkout.';
  } else {
    primary = compact ? 'Pricing unavailable' : 'Pricing unavailable. Purchase options are not configured.';
  }

  return (
    <div className="product-prices" role="group" aria-label="Price options">
      <p className={`product-price-primary${compact ? ' product-card-price' : ''}${status ? ' product-price-status' : ''}`}>
        {primary}
      </p>
      {secondaryCrypto.length ? (
        <div className="product-price-secondary" role="group" aria-label="Cryptocurrency prices">
          <p>
            Crypto (Solana):{' '}
            {secondaryCrypto.map((price, index) => (
              <Fragment key={price.currency}>
                {index > 0 ? ' / ' : ''}
                <span className="product-crypto-price">{price.amount} {price.currency}</span>
              </Fragment>
            ))}
          </p>
        </div>
      ) : null}
      {cardUnavailable ? <p className="product-price-secondary">Card pricing unavailable</p> : null}
    </div>
  );
}
